/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 *
 * @namespace classes.ArrayHelper
 */
const ArrayHelper = /** @lends classes.ArrayHelper*/ {
  /**
   * Removes all occurrences of an item from an array
   * @param {Array} array - The array to modify
   * @param {*} item - The element to remove
   * @returns {Array} The array after removal (not needed as argument array is modified)
   */
  remove: function (array, item) {
    let i;
    while ((i = array.indexOf(item)) >= 0) {
      array.splice(i, 1);
    }
    return array;
  },

  /**
   * Removes all elements from an array that match a given predicate
   * @param {Array} array - The array to filter
   * @param {Function} fn - A function that receives an element and returns true if it should be removed.
   * @returns {Array} The array after removal (not needed as argument array is modified)
   */
  removeMatching: function (array, fn) {
    let i = 0;
    if (typeof fn === "function") {
      while (i < array.length) {
        if (fn(array[i])) {
          array.splice(i, 1);
        } else {
          i++;
        }
      }
    }
    return array;
  },

  /**
   * Removes the element at a specific index
   * @param {Array} array - The array to modify
   * @param {number} index - The index of the element to remove.
   * @returns {Array} The array after removal (not needed as argument array is modified)
   */
  removeAt: function (array, index) {
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  },

  /**
   * Inserts an element into an array at a specific index.
   * @param {Array} array - The array to modify
   * @param {*} item - The element to insert
   * @param {number} index - The position at which to insert the element
   * @returns {Array} The array after insertion (not needed as argument array is modified)
   */
  insert: function (array, item, index) {
    if (index > -1) {
      array.splice(index, 0, item);
    }
    return array;
  },

  /**
   * Recursively flattens an array containing nested arrays.
   * @param {Array} array - The possibly nested array
   * @returns {Array} A new, flattened array
   */
  flatten: function (array) {
    return array.reduce(function (flat, toFlatten) {
      return flat.concat(Array.isArray(toFlatten) ? ArrayHelper.flatten(toFlatten) : toFlatten);
    }, []);
  },

  /**
   * Returns the last element of an array.
   * @param {Array} array - The array to read
   * @returns {*} The last element of the array
   */
  last: function (array) {
    return array.at(-1);
  }
};

modulum("ArrayHelper", function (context, cls) {
  cls.ArrayHelper = ArrayHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = ArrayHelper;
}
